

export enum DynFormSectionType {
    HEADER = 0,
    MIDDLE = 1,
    FOOTER = 2,
}